import { AB_TEST_QUERY_PARAM, AB_TEST_VARIANTS, isV3FunnelPath } from '~/composables/config/ab-test'
import { useDataLayer } from '~/composables/tracking/datalayer'
import { useAbTestStore } from '~/stores/ab-test'

// Reads the variant from the entry URL (before any redirect drops the query) and tells GA4 once the user
// is in the v3 funnel. Users the app did not put into an A/B test are not tracked.
export default defineNuxtPlugin(() => {
  const store = useAbTestStore()
  store.capture(new URLSearchParams(window.location.search).get(AB_TEST_QUERY_PARAM))

  const { pushToDataLayer } = useDataLayer()
  useRouter().afterEach((to) => {
    if (!store.param || !isV3FunnelPath(to.path))
      return

    const tag = AB_TEST_VARIANTS[store.param].tag
    pushToDataLayer({
      prebooking_version: tag,
      experiment_variant: tag,
    })
  })
})
